import { Typography } from '@mui/material';
import { FormatDateTimeInESTTimeZone } from 'src/utils/DateTimeHelper';
import { formattedMessageForPricelog, textColorStatus } from 'src/utils/Helper';

export const pricelogEntryMessage = row => {
  let message = '';
  if (row.sentToFirebrandDate) {
    message += `FITHub: Sent => ${FormatDateTimeInESTTimeZone(row.sentToFirebrandDate)}\n`;
  }
  if (row.updatedOnFirebrandDate) {
    message += `FITHub: Done => ${FormatDateTimeInESTTimeZone(row.updatedOnFirebrandDate)}\n`;
  }
  if (row.updatedOnEloquenceDate) {
    message += `Eloquence: Done => ${FormatDateTimeInESTTimeZone(row.updatedOnEloquenceDate)}\n`;
  }
  if (row.status === 'scheduled') {
    message += `${formattedMessageForPricelog(row)}\n`;
  }
  if (row.priceCheckCampops && row.priceCheckCampops.length > 0) {
    const updatedAt = row.priceCheckCampops[0].createdAt;
    message += `Retailers => ${FormatDateTimeInESTTimeZone(updatedAt)}\n`;
  }
  if (row.reason) {
    message += `Reason: ${row.reason}`;
  }
  return message;
};

export const renderPricelogEntryMessage = ({ row }) => {
  const message = pricelogEntryMessage(row);
  return (
    <Typography
      variant='caption'
      style={{ whiteSpace: 'pre-line' }}
      color={textColorStatus(row.status === 'scheduled' ? 'scheduled' : '')}
    >
      {message}
    </Typography>
  );
};
